// removed by extract-text-webpack-plugin
module.exports = {"buttonWrapper":"purify_HardwareButtonWrapper__buttonWrapper___1ouWf"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/HardwareButtonWrapper/HardwareButtonWrapper.scss
// module id = 194
// module chunks = 0